import React from 'react';

import { Toggle } from 'src/components/molecules/Toggle/Toggle';
import type { FacetOptionsProps } from './types';
import { formatOptionCount } from './utils/formatOptionCount';

export const onChange = (
  active: boolean,
  optionValue: string,
  facet: FacetOptionsProps['facet'],
  onFacetOptionChange: FacetOptionsProps['onFacetOptionChange'],
) => {
  const option = facet.options.find((opt) => opt.value === optionValue);

  if (option) {
    onFacetOptionChange({
      key: facet.key,
      title: facet.title,
      options: [
        {
          ...option,
          active,
          value: optionValue,
        },
      ],
    });
  }
};

export const FacetOptionsSingle = ({ boldText, facet, onFacetOptionChange }: FacetOptionsProps) => {
  const handleToggle = (active: boolean, optionValue: string) => {
    onChange(active, optionValue, facet, onFacetOptionChange);
  };

  return (
    <>
      {facet.options.map((option) => (
        <Toggle
          active={option.active}
          boldText={boldText}
          disabled={!option.active && option.count === 0}
          href={option.href}
          key={option.value}
          label={option.title}
          name={facet.key} // Use facet key as the group name for mutually exclusive behavior
          onToggle={(active) => handleToggle(active, option.value)}
          secondaryLabelText={formatOptionCount(option.count)}
          value={option.value}
        />
      ))}
    </>
  );
};
